import { AUTH_API_BASE } from '../config/vars';
import { call } from './http';

export const users = {
  list: (orgId) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/users?query[ownerOrgId]=${orgId}&pageSize=500`,
      fetchOptions: { method: 'GET' }
    });
  },
  listAdopted: (orgId) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/adopted-users?query[ownerOrgId]=${orgId}&pageSize=500`,
      fetchOptions: { method: 'GET' }
    });
  },
  delete: (userId) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/users/${userId}`,
      fetchOptions: { method: 'DELETE' },
      responseExpected: false
    });
  },
  update: (userId, userObject) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/users/${userId}`,
      fetchOptions: { method: 'PUT', body: JSON.stringify(userObject) }
    });
  },
  organisationsForUser: (userId, silent = false) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/users/${userId}/organisations`,
      fetchOptions: { method: 'GET' },
      otherOptions: {
        disableErrorToasts: silent,
        disable401Toast: silent,
      }
    });
  },
  rolesForUser: (userId, orgId) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/users/${userId}/roles?query[orgId]=${orgId}`,
      fetchOptions: { method: 'GET' },
    });
  },
  addRole: (userId, orgId, roleId) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/users/${userId}/roles`,
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({ orgId, roleId: Number(roleId) })
      }
    });
  },
  removeRole: (userId, orgId, roleId) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/users/${userId}/roles/${roleId}?query[orgId]=${orgId}`,
      fetchOptions: { method: 'DELETE' },
      responseExpected: false
    });
  }
};

export const roles = {
  list: () => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/roles?pageSize=100&orderBy=id`,
      fetchOptions: { method: 'GET' }
    });
  }
};

export const adminRoles = {
  list: (silent = false) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/admin-roles?pageSize=100&orderBy=id`,
      fetchOptions: { method: 'GET' },
      otherOptions: {
        disableErrorToasts: silent,
        disable401Toast: silent,
      }
    });
  }
};

export const invite = {
  // targetApp is optional. When it is undefined the key is omitted and the
  // auth service applies its default (webclient).
  send: (email, roleIds, org, targetApp) => {
    const body = JSON.stringify({
      email,
      roles: roleIds,
      invitingOrgName: org.name,
      orgToInviteTo: org.id,
      ...(targetApp ? { targetApp } : {})
    });

    return call({
      path: `${AUTH_API_BASE}/api/v1/invite-user`,
      fetchOptions: { method: 'POST', body },
      responseExpected: false
    });
  }
};

const generateAllOrgsQuery = allOrgs => {
  return allOrgs.reduce(
    (acc, org, index) =>
      `${acc}${index === 0 ? '' : '&'}query[orgId]=${org.id}`,
    ''
  );
};

export const roles_users = {
  list: (roleId, allOrgs) => {
    const allOrgsQs = generateAllOrgsQuery(allOrgs);
    return call({
      path: `${AUTH_API_BASE}/api/v1/roles/${roleId}/users?pageSize=500&${allOrgsQs}&orderBy=id`,
      fetchOptions: { method: 'GET' }
    });
  }
};

export const adminRoles_users = {
  list: (roleId, allOrgs) => {
    const allOrgsQs = generateAllOrgsQuery(allOrgs);
    return call({
      path: `${AUTH_API_BASE}/api/v1/admin-roles/${roleId}/users?pageSize=500&${allOrgsQs}&orderBy=id`,
      fetchOptions: { method: 'GET' }
    });
  }
};

export const adminRoles_capabilities = {
  list: (roleId) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/admin-roles/${roleId}/capabilities?pageSize=500&&orderBy=id`,
      fetchOptions: { method: 'GET' }
    });
  },
  create: (roleId, capabilityId) => {
    const body = JSON.stringify({
      capabilityId: Number(capabilityId)
    });
    return call({
      path: `${AUTH_API_BASE}/api/v1/admin-roles/${roleId}/capabilities`,
      fetchOptions: { method: 'POST', body }
    });
  }
};

export const capabilities = {
  list: (silent = false) => {
    return call({
      path: `${AUTH_API_BASE}/api/v1/capabilities?pageSize=500&&orderBy=id`,
      fetchOptions: { method: 'GET' },
      otherOptions: {
        disableErrorToasts: silent,
        disable401Toast: silent,
      }
    });
  },
  create: (capability) => {
    const body = JSON.stringify(capability);
    return call({
      path: `${AUTH_API_BASE}/api/v1/capabilities`,
      fetchOptions: { method: 'POST', body }
    });
  }
};
